import { Injectable, Injector } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { LoggerService } from '../services/logger.service';

@Injectable({
  providedIn: 'root'
})
export class CustomMsalGuard implements CanActivate {
  msalGuard: MsalGuard;
  constructor(private injector: Injector, private logger: LoggerService) {
    if (!environment.inMemoryWebApiEnabled) {
      this.msalGuard = this.injector.get(MsalGuard);
    }
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (environment.inMemoryWebApiEnabled) {
      this.logger.debug(`[AuthFlow][CustomMsalGuard] bypassed (inMemoryWebApiEnabled=true) for route: ${state?.url || 'unknown'}`, 'auth');
      return true;
    }

    if (!this.msalGuard) {
      this.logger.error(`[AuthFlow][CustomMsalGuard] msalGuard not initialized for route: ${state?.url || 'unknown'}`);
      return false;
    }

    this.logger.debug(`[AuthFlow][CustomMsalGuard] evaluating route: ${state?.url || 'unknown'}`, 'auth');
    const guardResult = this.msalGuard.canActivate(route, state);

    if (this.isObservable(guardResult)) {
      return guardResult.pipe(
        tap((result) =>
          this.logger.debug(`[AuthFlow][CustomMsalGuard] observable result for ${state?.url || 'unknown'}: ${result}`, 'auth')
        )
      );
    }

    this.logger.debug(`[AuthFlow][CustomMsalGuard] sync result for ${state?.url || 'unknown'}: ${guardResult}`, 'auth');
    return guardResult;
  }

  private isObservable(value: any): value is Observable<boolean | UrlTree> {
    return !!value && typeof value.subscribe === 'function';
  }
}
